/**
 * 外链支付确认会话标志。
 *
 * 外链支付（PayLinkModal）的产品要求：首充 WebPush 弹窗须等用户点击「我已付款」
 * 后由 handleRechargeSuccess 触发；会话进行中后端 WS RECHARGE_SUCCESS 先到时
 * 不得抢先 dispatch（useUserEvents 据此跳过）。
 *
 * 会话生命周期：setPayData 打开外链确认弹窗时置位；支付成功 / 取消关闭弹窗时清除。
 * 模块级变量即可——页面刷新后 payData 状态本身也已丢失，无需持久化。
 */
let active = false;
/** 会话期间是否收到过 WS RECHARGE_SUCCESS：点「我已付款」只有真到账才弹（假点不弹） */
let rechargeConfirmedDuringSession = false;

export function markPayLinkConfirmSessionActive(): void {
  active = true;
  rechargeConfirmedDuringSession = false;
}

export function clearPayLinkConfirmSession(): void {
  active = false;
  rechargeConfirmedDuringSession = false;
}

export function isPayLinkConfirmSessionActive(): boolean {
  return active;
}

/** WS 到账时调用；仅会话进行中才记录（自带守卫，调用方无需判断） */
export function markRechargeConfirmedDuringPayLinkSession(): void {
  if (active) rechargeConfirmedDuringSession = true;
}

export function wasRechargeConfirmedDuringPayLinkSession(): boolean {
  return rechargeConfirmedDuringSession;
}
